module.exports = __webpack_public_path__ + "img/pk_sense.f4a7c0bf.png";